import AnkitaGuha from "../../assets/headshots/Ankita Guha.png"
import HudaHussaini from "../../assets/headshots/Huda Hussaini.png"
import JennaRitten from "../../assets/headshots/Jenna Ritten.png"
import KanikaMohan from "../../assets/headshots/Kanika Mohan.png"
import AnikaRaisa from "../../assets/headshots/AnikaRaisa.jpg"
import AnithaPalanivel from "../../assets/headshots/Anitha Palanivel.png"
import MedhaMuppala from "../../assets/headshots/Medha Muppala.png"
import GayathriChava from "../../assets/headshots/GayathriChava.jpg"
import DivyaLakshmi from "../../assets/headshots/Divya Lakshmi.png"
import Namaa from "../../assets/headshots/Namaa.jpg"
import WhitneyTran from "../../assets/headshots/WhitneyTran.jpg"
import MusaShoeb from "../../assets/headshots/MusaShoeb.jpg"
import BandhanKaur from "../../assets/headshots/Bandhan Kaur.png"
import Rehanashri from "../../assets/headshots/Rehanashri.jpg"

const devTeamData = [
    {
        imageurl: AnithaPalanivel,
        name: "Anitha Palanivel",
        linkedIn: "https://www.linkedin.com/in/anitha-palanivel-69225a15",
        status: "Senior Database Administrator @ OneMagnify",
    },
    {
        imageurl: BandhanKaur,
        name: "Bandhan Kaur",
        linkedIn: "https://www.linkedin.com/in/bandhanpreet-kaur/",
        status: "Software Engineer @ Excelerate America",
    },
    {
        imageurl: AnkitaGuha,
        name: "Ankita Guha",
        linkedIn: "https://www.linkedin.com/in/ankita-guha-4dscience/",
        status: "Data Analyst Programmer @ Freudenberg Group"
    },
    {
        imageurl: DivyaLakshmi,
        name: "Divya Lakshmi",
        linkedIn: "www.linkedin.com/in/divyalakshmi-vrps",
        status: "Business Technology Testing Intern @ Nucor Corporation",
    },
    {
        imageurl: HudaHussaini,
        name: "Huda Hussaini",
        linkedIn: "https://www.linkedin.com/in/hussainihuda/",
        status: "Cyber Security Software Engineer @ ETAS"
    },
    {
        imageurl: JennaRitten,
        name: "Jenna Ritten",
        linkedIn: "https://www.linkedin.com/in/jritten/",
        status: "Chief Developer Advocate & Architect @ iBM",
    },
    {
        imageurl: KanikaMohan,
        name: "Kanika Mohan",
        linkedIn: "https://www.linkedin.com/in/kanikamohan7",
        status: "Product Manager @ IBM",
    },
    {
        imageurl: AnikaRaisa,
        name: "Anika Raisa",
        linkedIn: "https://www.linkedin.com/in/anikaraisa/",
        status: "Data Scientist and Computer Engineer @ University of Michigan",
    },
    {
        imageurl: MedhaMuppala,
        name: "Medha Muppala",
        linkedIn: "https://www.linkedin.com/in/medhamuppala/",
        status: "Product Designer @ Jameo",
    },
    {
        imageurl: Rehanashri,
        name: "Rehanashri GR",
        linkedIn: "https://www.linkedin.com/in/rehanashri?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
        status: "Graduate Student @ University of Michigan-Dearborn ",
    }
    
]
export default devTeamData;
